import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../config';
import { Link } from 'react-router';

let App = window.App;
let $ = window.jQuery;

export default class AppointmentItem extends Component {

    getStatus = () => {
        if (this.props.status === 'pending') {
            return (
                <small className="label label-sm label-warning">
                    {this.props.status.toUpperCase()}
                </small>
            )
        }

        if (this.props.status === 'completed') {
            return (
                <small className="label label-sm label-primary">
                    {this.props.status.toUpperCase()}
                </small>
            )
        }

        if (this.props.status === 'cancelled') {
            return (
                <small className="label label-sm label-danger">
                    {this.props.status.toUpperCase()}
                </small>
            )
        }
    };

    handleOpenModal = (e) =>  {

        if (typeof this.props.patient === 'undefined') {
            return false;
        }

        if (! this.props.patient) {
            return false;
        }

        let data = {
            appointmentId: this.props.appointment_id,
            patientId: this.props.patient_id,
            patientName: this.props.patient.firstname,
            patientLast: this.props.patient.lastname,
            appointmentDate: this.props.date,
            startTime: this.props.start_time,
            endTime: this.props.end_time,
            procedure: this.props.procedure_id,
            emailAddress: this.props.email,
            mobileNumber: this.props.phone,
            branch: this.props.facility_id,
            dentist: this.props.practitioner_id,
            dentalChair: this.props.chair_number,
            remarks: this.props.remarks
        };

        this.props.viewAppointment(data);
    };

    updateAppointmentStatus = (status, appointmentId) => {
        App.blockUI({
            target: 'body',
            boxed: true
        });

        let url = `${config.apiUrl}dental/appointments/${appointmentId}/status`;

        axios.post(url, {status: status}).then((res) => {
            // this.props.onUpdatedAppointmentStatus(res.data.data);
            this.props.putAppointmentSuccess(res.data.data);
            App.unblockUI('body');
        }).catch((res) => {
            // this.props.onUpdatedAppointmentStatus(res.data.data);
            App.unblockUI('body');
        });
    };

    handleErrorImg = (e) => {
        e.target.src = '/images/generic_profile_pic.png';
    };

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    componentDidMount() {
        let self = this;

        $('.cancelAppointment').confirmation({
            title: 'Are you sure to cancel this appointment?',
            popout: true,
            btnOkClass: 'btn btn-primary btn-sm',
            btnCancelClass: 'btn btn-danger btn-sm',
            container: 'body',
            onConfirm: function() {
                let appointmentId = $(this).attr('data-appointment');
                self.updateAppointmentStatus('cancelled', appointmentId);
            }
        });

        $('.completeAppointment').confirmation({
            title: 'Are you sure to complete this appointment?',
            popout: true,
            btnOkClass: 'btn btn-primary btn-sm',
            btnCancelClass: 'btn btn-danger btn-sm',
            container: 'body',
            onConfirm: function() {
                let appointmentId = $(this).attr('data-appointment');
                self.updateAppointmentStatus('completed', appointmentId);
            }
        });


        // Initialize tooltip
        $('.tooltips').tooltip();
    }

    render() {
        let status = this.getStatus();

        let mediaId = 0;

        if (this.props.patient) {
            if (this.props.patient.media_id !== null) {
                mediaId = this.props.patient.media_id
            }
        }

        let imageUrl = `${config.staticFiles}${mediaId}`;

        // eslint-disable-next-line
        if (! mediaId || mediaId == 0 || mediaId == null) {
            imageUrl = '/images/generic_profile_pic.png';
        }

        return (
            <li className={`mt-list-item patientItem mt-element-overlay ${this.props.status}`}>
                <div className="mt-overlay-1 patientItemContent">
                    <div className="row">
                        <div className="col-md-2 col-sm-2 col-xs-2">
                            <img src={imageUrl} alt=""
                                 onError={this.handleErrorImg}
                                 className="img-circle" style={{ width: '100%' }}/>
                        </div>

                        <div className="col-md-5 col-sm-5 col-xs-5" style={{lineHeight: '0.2em', textAlign: 'left'}}>
                            <h4 className="uppercase bold">
                                <Link to={`/patients/2015000001`}>{this.props.patient_name}</Link>
                            </h4>
                            <p style={{ lineHeight: '0.8em' }}>{this.props.remarks}</p>
                            <p style={{ lineHeight: '0.8em' }}>{this.props.procedure}</p>
                            {status}
                        </div>

                        <div className="col-md-5 col-sm-5 col-xs-5 pull-right" style={{ textAlign: 'right', marginTop: '10px' }}>
                            <div className="col-md-12">
                                {this.props.date}
                            </div>
                            <div className="col-md-12">
                                {this.props.time}
                            </div>
                            <div className="col-md-12">
                                {this.props.facility + ' (Chair No. ' + this.props.chair_number + ')' }
                            </div>
                            <div className="col-md-12">
                                <strong><em>{this.props.practitioner_name}</em></strong>
                            </div>
                        </div>
                    </div>

                    <div className="mt-overlay">
                        <ul className="mt-info">
                            <li>
                                <a className="btn default btn-outline tooltips" href="#newAppointmentModal" data-toggle="modal"
                                   data-placement="bottom"
                                   data-original-title="View Appointment"
                                   onClick={this.handleOpenModal}>
                                    <i className="glyphicon glyphicon-eye-open" />
                                </a>
                            </li>
                            <li>
                                <Link to={`/patients/${this.props.patient_id}?action=new_consult`}
                                      data-placement="bottom"
                                      data-original-title="Start Consultation"
                                      className="btn default btn-outline tooltips">
                                    <i className="fa fa-stethoscope"/>
                                </Link>
                            </li>
                            <li>
                                <a className="btn default btn-outline blue completeAppointment tooltips" href="#"
                                   data-placement="bottom"
                                   data-original-title="Complete Appointment"
                                   data-appointment={this.props.appointment_id}
                                   data-toggle="confirmation" data-singleton="true">

                                    <i className="glyphicon glyphicon-ok"/>
                                </a>
                            </li>
                            <li>
                                <a className="btn default btn-outline red cancelAppointment tooltips" href="#"
                                   data-placement="bottom"
                                   data-original-title="Cancel Appointment"
                                   data-appointment={this.props.appointment_id}
                                   data-toggle="confirmation" data-singleton="true">

                                    <i className="glyphicon glyphicon-remove"/>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div style={{ clear: 'both' }}></div>
            </li>
        )
    }
}

AppointmentItem.contextTypes = {
    router: React.PropTypes.object.isRequired
};


/** WEBPACK FOOTER **
 ** ./src/components/home/AppointmentItem.js
 **/